import { render, staticRenderFns } from "./Appointment.vue?vue&type=template&id=ea8e10b6&scoped=true&"
import script from "./appointment.js?vue&type=script&lang=js&"
export * from "./appointment.js?vue&type=script&lang=js&"
import style0 from "../appointments.scss?vue&type=style&index=0&id=ea8e10b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8e10b6",
  null
  
)

export default component.exports